import { Paginated } from '@/modules/shared/models/data'
import { vservice } from '@niknevis/vue-modules'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { collect } from 'collect.js'

@vservice()
export default class EntitySearchService<T> {
  entitySearch(route: string, s: string, page: number, params: Record<string, any> = {}): Promise<Paginated<T[]>> {
    return HTTP.get(
      route,
      { searchParams: collect({ s, page, ...params }).filter().all() }
    ).then(response => response.json())
  }
}